import React from "react";
import "./TextBox.css";
import API from "../../utils/API";
import { withRouter } from "react-router";
import Inventory from "../Inventory/Inventory";
import { Link } from "react-router-dom";

let userName = "You";

//our story elements that don't require a userName
const storyObj = {
  home: {
    start: {
      p3: " A traveler steps from the light. 'I'm Wilson. This realm is in danger, and I need your help.' ",
      p4: " The king is trapped inside the castle. Take these 10 gold coins for the journey, and choose your destination wisely. ",
    },
  },
};

//The text box for continue.js
class TextBox extends React.Component {
  timeouts = [];

  state = {
    storyString: "",
    image: this.props.avatar || "placeholder.gif",
    name: "Misterman",
    poofShow: "hide",
    homeFirst: true,
    lives: "",
    money: 0,
    gameLog: "",
    wilsonShow: "hide",
  };

  schedule = (callback, delay) => {
    const timeout = setTimeout(callback, delay);
    this.timeouts.push(timeout);
    return timeout;
  };

  componentWillUnmount() {
    this.timeouts.forEach(clearTimeout);
  }

  //when the page loads
  componentDidMount() {
    // get the id from the parameters
    const id = this.props.match.params.id;

    const applyUserData = (user) => {
      const { name, sprite, homeFirst, lives, money } = user.sprite[0];

      userName = name;
      this.setState({ image: sprite, homeFirst, lives, money });

      if (homeFirst === true) {
        this.setState({
          storyString:
            userName +
            " awakens in a strange new land. Four paths lead from a sunlit meadow: a shadowy forest, a towering cliff, a quiet village, and a castle glowing in the distance. Which path will they choose? The air shimmers—POOF! ",
        });
        this.schedule(this.poofAppears, 9000);
      } else {
        this.setState({
          storyString: userName + " enters where they first came into the land. " + userName + " looks around and decides what to do. ",
        });
      }
    };

    const getUserData = async () => {
      const userData = await API.getUser(id);
      const user = await userData.json();
      applyUserData(user);
    };

    if (this.props.user) applyUserData(this.props.user);
    else getUserData();

  }

  //Shows the Poof gif and then runs the next function
  poofAppears = () => {
    this.setState({ poofShow: "show" });
    this.updateStory("A sudden flash of light erupts beside " + userName + "—POOF! ");
    this.schedule(this.wilsonAppears, 3000);
  };

  //Shows the image of wilson and he starts to talk and then runs the next function
  wilsonAppears = () => {
    this.updateStory(storyObj.home.start.p3);
    this.setState({ poofShow: "hide", wilsonShow: "show" });
    this.schedule(this.wilsonTalks, 5000);
  };

  //Wilson talks and gives you money and then runs the next function
  wilsonTalks = () => {
    const id = this.props.match.params.id;

    this.updateStory(storyObj.home.start.p4);
    //updates our money database to 10
    API.UpdateSpriteMoney(10, id).then(() => {
      console.log("updated money");
      this.setState({ money: 10 });
    });

    this.schedule(this.wilsonGoes, 6000);
  };

  //Wilson image goes, and he poof shows. Updates homefirst so this sequence doesn't run again. And then runs the next functions
  wilsonGoes = () => {
    const id = this.props.match.params.id;
    this.setState({ wilsonShow: "hide" });
    this.setState({ poofShow: "show" });

    API.UpdateSpriteHomeFirst(false, id).then(() => {
      console.log("updated homeFirst");
    });

    this.schedule(this.poofGoes, 3000);
  };

  //Hides the poof image and then runs the function that updates the story database
  poofGoes = () => {
    this.setState({ poofShow: "hide" });
    this.updateStory(
      "Before " +
      userName +
      " can ask another question, Wilson vanishes in a swirl of light. Now the choice is yours: forest, cliffs, village, or castle. "
    );
    this.createStory();
  };

  renderStory = () => this.state.storyString.split(/(10 gold)/gi).map((part, index) => (
    /10 gold/i.test(part)
      ? <span className="gold-reward" key={index}>{part}</span>
      : part
  ));

  //function to set the state with the string given in the parameter
  updateStory = (storyObjectPath) => {
    this.setState({
      storyString: this.state.storyString + " " + storyObjectPath,
    });
  };

  //Our function that creates our story for our user so that we can update it in the future
  createStory = () => {
    const id = this.props.match.params.id;
    let postObj = {
      text: this.state.storyString,
    };
    API.createStory(postObj, id)
      .then((res) => console.log("story created"))
      .catch((err) => console.log(err));
  };

  //Gets the full story when you click on the button
  findGameLog = () => {
    const id = this.props.match.params.id;
    API.getUserStory(id).then((user) => {
      const { text } = user.data[0].story[0];
      this.setState({ gameLog: text });
    });
  };

  render() {
    return (
      <div>
        {/* Our textbox for this page */}
        <div className="mapBG">
          <div ref="scroll" className="story-copy">{this.renderStory()}</div>
        </div>

        {/* Pass our props to our inventory so they change in page */}
        <Inventory money={this.state.money} userSprite={this.props.user && this.props.user.sprite[0]} />

        {/* Our menu buttons */}
        <div className="card-body text-center">
          <p></p>
          <h5>Menu</h5>

          {/* Logs you out of the game */}
          <Link to="/">
            <button type="button" className="btn">
              Log Out!
            </button>
          </Link>

          {/* Pulls up GameLog */}
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.findGameLog}
            data-toggle="modal"
            data-target="#game-log"
          >
            Game Log!
          </button>
        </div>

        <div className={this.state.poofShow}>
          <img
            className="poof-image"
            src={require("../../images/prettypoof.gif")}
          />
        </div>

        <div className={this.state.wilsonShow}>
          <img
            className="appear-image"
            src={require("../../assets/sprites/wilson.gif")}
          />
        </div>
        <div>
          <img
            className="avatar-image"
            src={require("../../assets/sprites/1-" + this.state.image)}
          />
        </div>

        {/* Our game log modal */}
        <div
          className="modal fade"
          id="game-log"
          data-backdrop="static"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  The Story so far...
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="scroll-log">{this.state.gameLog}</div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TextBox);
